import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d13c494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-detail" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"position":"relative","top":"-43px","left":"109px"} }, "m²", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = { class: "project-detail-house" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("返回列表")

import { Plus, UploadFilled } from "@element-plus/icons-vue";
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type {
  UploadFile,
  ElUploadProgressEvent,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

interface projectVo {
  id: string;
  name: string;
  province: string;
  city: string;
  area: string;
  address: string;
  houseNatureId: string;
  decorateTypeId: string;
  phase: string;
  companyAreaId: string;
  coverArea: string;
  unit: string;
  deliveryDate: string;
  roomNumber: string;
  houseAveragePriceCode: string;
  deliveryBatchCode: string;
  remark: string;
  housePropertys: housePropertyVo[];
  housePropertyJson: string;
}
interface housePropertyVo {
  name: string;
  imgUrl: string;
  id: string;
  area: string;
  thumbnailUrl: string;
}
type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const imageListDialogImageUrl = ref("");
const imageListDialogVisible = ref(false);
const imageListDisabled = ref(false);
const value1 = ref("");

const housePropertyData: housePropertyVo = {
  name: "",
  imgUrl: "",
  id: "",
  area: "",
  thumbnailUrl: "",
};
const createOrEditFormData: projectVo = {
  id: "",
  name: "",
  province: "",
  city: "",
  area: "",
  address: "",
  houseNatureId: "",
  decorateTypeId: "",
  phase: "",
  companyAreaId: "",
  coverArea: "",
  unit: "公顷",
  deliveryDate: "",
  roomNumber: "",
  houseAveragePriceCode: "",
  deliveryBatchCode: "",
  remark: "",
  housePropertys: [],
  housePropertyJson: "",
};
const projectFormRef = ref<FormInstance>();
const bindData = reactive({
  createOrEditFormData: createOrEditFormData,
  houseNatures: [],
  decorateTypes: [],
  companyAreas: [],
  actionUrl: tool.url("/middle/project/uploadHousePropertyImg"),
  areaId: "",
});

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  bindData.createOrEditFormData.id = id;
} else {
  var i;
  for (i = 0; i < id.length; i++) {
    bindData.createOrEditFormData.id = id[i];
  }
}

const validateName = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入项目名称"));
  } else {
    callback();
  }
};


const validateRoomNumberCode = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入交房户数"));
  } else {
    callback();
  }
};

const projectRules = reactive({
  name: [{ required: true, validator: validateName, trigger: "blur" }],
  roomNumberCode: [{ required: true, validator: validateRoomNumberCode, trigger: "blur" },
                   { type: 'number', message: '交房户数必须为数字值'}]
});

const saveEvent = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      var id = bindData.createOrEditFormData.id;
      if ("add" == id) {
        bindData.createOrEditFormData.id = "";
      }
      bindData.createOrEditFormData.housePropertyJson = JSON.stringify(
        bindData.createOrEditFormData.housePropertys
      );
      store
        .dispatch("projectModule/saveProject", bindData.createOrEditFormData)
        .then(
          (data) => {
            bindData.createOrEditFormData.id = data.result;
            ElMessage.success(data.msg);
            toProjectDetail(data.result);
          },
          (error) => {
            console.log(error.msg);
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};

const houseNatureEvent = () => {
  store
    .dispatch("projectModule/listHouseNature", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.houseNatures = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const decorateTypeEvent = () => {
  store
    .dispatch("projectModule/listDecorateType", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.decorateTypes = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const companyAreaEvent = () => {
  store
    .dispatch("projectModule/listCompanyArea", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.companyAreas = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const projectEvent = () => {
  store
    .dispatch("projectModule/getProject", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.createOrEditFormData = data.result;
        bindAreaData(data.result.area);
      },
      (error) => {
        console.log(error.msg);
      }
    );
};
const housePropertyEvent = () => {
  store
    .dispatch("projectModule/listHouseProperty", bindData.createOrEditFormData)
    .then(
      (data) => {
        bindData.createOrEditFormData.housePropertys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};
houseNatureEvent();
decorateTypeEvent();
companyAreaEvent();
var lid = bindData.createOrEditFormData.id;
if (lid && lid != "add") {
  projectEvent();
  housePropertyEvent();
}
const toProjectDetail = (id: string) => {
  router.push("/middleGround/project/projectList/projectDetail/" + id);
};

const toProjectList = () => {
  router.push("/middleGround/project/projectList");
};

const handleRemoveImg = (imgUrl: string) => {
  const housePropertys = bindData.createOrEditFormData.housePropertys;
  const tempHousePropertys = [];
  for (const housePropety of housePropertys) {
    if (housePropety.imgUrl != imgUrl) {
      tempHousePropertys.push(housePropety);
    }
  }
  bindData.createOrEditFormData.housePropertys = tempHousePropertys;
};

const uploadSuccessEvent = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  const housePropertyData = {
    name: "",
    imgUrl: "",
    id: "",
    area: "",
    thumbnailUrl: "",
  };
  housePropertyData.thumbnailUrl = URL.createObjectURL(file.raw);
  housePropertyData.imgUrl = response.result;
  bindData.createOrEditFormData.housePropertys.push(housePropertyData);
};

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    //省
    const firstValue = value[value.length - 3];
    var province = tool.areaCodeToText.get(firstValue);
    if (province != undefined) {
      bindData.createOrEditFormData.province = province;
    }
    //市
    const secordValue = value[value.length - 2];
    var city = tool.areaCodeToText.get(secordValue);
    if (city != undefined) {
      bindData.createOrEditFormData.city = city;
    }
    //取最后一个
    const lastValue = value[value.length - 1];
    var areaName = tool.areaCodeToText.get(lastValue);
    bindData.areaId = lastValue;
    if (areaName != undefined) {
      bindData.createOrEditFormData.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  var areaValue = tool.areaTextToCode.get(areaName);
  if (areaValue != undefined) {
    bindData.areaId = areaValue;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "projectFormRef",
      ref: projectFormRef,
      model: _unref(bindData).createOrEditFormData,
      "label-width": "120px",
      inline: false,
      size: "default",
      rules: _unref(projectRules),
      class: "projectForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "项目名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
              "input-style": "width: 218px",
              placeholder: "请输入项目名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "楼盘性质" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.houseNatureId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).createOrEditFormData.houseNatureId) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).houseNatures, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "装修类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.decorateTypeId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).createOrEditFormData.decorateTypeId) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).decorateTypes, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "阶段" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.phase,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).createOrEditFormData.phase) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "新盘",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "次新盘",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "存量盘",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "所属公司区域" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.companyAreaId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).createOrEditFormData.companyAreaId) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).companyAreas, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "项目地址" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).areaId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).areaId) = $event))
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.address,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.address) = $event)),
              "input-style": "width: 218px;margin-top: 5px;",
              placeholder: "请输入详细地址"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "交房日期" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(bindData).createOrEditFormData.deliveryDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.deliveryDate) = $event)),
              "value-format": "YYYY-MM-DD",
              type: "date",
              placeholder: "选择日期"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "交房户数",
          prop: "roomNumberCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              placeholder: "请输入交房户数",
              modelValue: _unref(bindData).createOrEditFormData.roomNumber,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.roomNumber) = $event)),
              modelModifiers: { number: true },
              "input-style": "width:220px;"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "房屋均价" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.houseAveragePriceCode,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).createOrEditFormData.houseAveragePriceCode) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "<1万",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "1~2万",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "2~3万",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "3~5万",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "5~10万",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: ">10万",
                  value: 6
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "交付批次" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(bindData).createOrEditFormData.deliveryBatchCode,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).createOrEditFormData.deliveryBatchCode) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "第1批",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "第2批",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "第3批",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "第4批",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "第5批",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "第6批及以上",
                  value: 6
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "介绍" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "project-detail-textarea",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).createOrEditFormData.remark) = $event))
            }, null, 512), [
              [_vModelText, _unref(bindData).createOrEditFormData.remark]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "户型资料" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).createOrEditFormData.housePropertys, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "project-detail-house",
                    key: item.id
                  }, [
                    (item.thumbnailUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.thumbnailUrl,
                          class: "avatar"
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (item.thumbnailUrl)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 1,
                          placeholder: "户型名称",
                          modelValue: item.name,
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          "input-style": "margin-bottom:10px"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (item.thumbnailUrl)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 2,
                          placeholder: "户型面积",
                          modelValue: item.area,
                          "onUpdate:modelValue": ($event: any) => ((item.area) = $event),
                          "input-style": "margin-bottom:10px"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    _hoisted_4,
                    (item.thumbnailUrl)
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 3,
                          type: "primary",
                          onClick: ($event: any) => (handleRemoveImg(item.imgUrl)),
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _unref(bindData).actionUrl,
                    "show-file-list": false,
                    "on-success": uploadSuccessEvent
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["action"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_container, { class: "project-detail-btn" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElButton), {
          type: "primary",
          size: "large",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (saveEvent(projectFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          size: "large",
          onClick: toProjectList
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})